import moment from "jalali-moment";

export function convertToJalali(dateInput) {
  if (!dateInput) return null;
  const gregorianDate = new Date(dateInput); // Parse input as a Date object
  const jalaliDate = moment(gregorianDate).locale("fa").format("jYYYY-jMM-jDD");
  return jalaliDate;
}

export function addOneDay(dateInput) {
  if (!dateInput) return null;
  const jalaliMoment = moment(dateInput, "jYYYY-jMM-jDD HH:mm").locale("fa");

  jalaliMoment.add(1, "day");

  return jalaliMoment.format("jYYYY-jMM-jDD");
}

export function formatReminders(reminders) {
  const colorMapping = {
    danger: { backgroundColor: "#ffcccc", textColor: "#a00" }, // Light red
    primary: { backgroundColor: "#cce5ff", textColor: "#004085" }, // Light blue
    warning: { backgroundColor: "#fff3cd", textColor: "#856404" }, // Light yellow
    success: { backgroundColor: "#d4edda", textColor: "#155724" }, // Light green
  };

  return reminders.map((reminder) => {
    const color =
      colorMapping[reminder.color.toLowerCase()] || colorMapping["primary"];
    return {
      ...reminder,
      id: reminder.id,
      title: reminder.title,
      start: reminder.start_date.split(" ")[0],
      end: reminder.end_date.split(" ")[0],
      backgroundColor: color.backgroundColor,
      textColor: color.textColor,
      borderColor: "#00000000",
    };
  });
}

export function lightenColor(color, percent) {
  const num = parseInt(color.replace("#", ""), 16),
    amt = Math.round(2.55 * percent),
    R = (num >> 16) + amt,
    G = ((num >> 8) & 0x00ff) + amt,
    B = (num & 0x0000ff) + amt;
  return `#${(
    0x1000000 +
    (R < 255 ? (R < 1 ? 0 : R) : 255) * 0x10000 +
    (G < 255 ? (G < 1 ? 0 : G) : 255) * 0x100 +
    (B < 255 ? (B < 1 ? 0 : B) : 255)
  )
    .toString(16)
    .slice(1)}`;
}

export function formatLeadItemDate(date) {
  const d = new Date(date);
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}
